<div class="data-container-wrapper">
  @if (title()) {
    <div class="data-container-header">
      <div class="data-container-header__content">
        @if (icon()) {
          <span class="data-container-header__icon material-icons">{{ icon() }}</span>
        }
        <h3 class="data-container-header__title">{{ title() }}</h3>
      </div>
    </div>
  }

  <div class="data-container-body">
    <ng-content></ng-content>
  </div>
</div>
